import { Lang, Viewport } from '../../types';

export type AllowedCookies = {
  lang: Lang;
  viewport: Viewport;
  'better-auth.session_token'?: string;
  '__Secure-better-auth.session_token'?: string;
  'cookie-consent'?: boolean;
};

export const defaultCookies: AllowedCookies = {
  lang: 'pl',
  viewport: 'd',
};
